import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './PynwheelConnect.css';

interface PynwheelConnectProps {
    url: string;
    propertyName?: string;
}

const PynwheelConnect: React.FC<PynwheelConnectProps> = ({ url, propertyName }) => {
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(true);

    return (
        <div className="pynwheel-container">
            <div className="pynwheel-header">
                <button className="pynwheel-back-btn" onClick={() => navigate(-1)}>
                    <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    >
                        <path d="M19 12H5M12 19l-7-7 7-7" />
                    </svg>
                    <span>Back to Appointments</span>
                </button>
                <div className="pynwheel-title">
                    {propertyName}
                </div>
            </div>
            <div className="pynwheel-iframe-wrapper">
                {isLoading && (
                    <div className="pynwheel-loader-container">
                        <div className="pynwheel-spinner"></div>
                        <p>Loading pynwheelconnect map...</p>
                    </div>
                )}
                <iframe
                    src={url}
                    title="Pynwheel Connect Interactive Map"
                    className={`pynwheel-iframe ${isLoading ? 'hidden' : 'visible'}`}
                    allow="geolocation"
                    frameBorder="0"
                    onLoad={() => setIsLoading(false)}
                />
            </div>
        </div>
    );
};

export default PynwheelConnect;
